import { Layout } from 'client/app/apps/disco-prototype/components/PlateMapCanvas/common';
import { getColumnLabels, getRowLabels } from 'common/types/disco/wellCoords';

export const drawHeaders = (ctx: CanvasRenderingContext2D, layout: Layout) => {
  if (!layout.showHeaders) return;

  const { cellW, cellH, numColumns, numRows } = layout;

  ctx.save();
  ctx.font = `${Math.round(Math.min(cellW, cellH) * 0.4)}px sans-serif`;
  ctx.fillStyle = '#000';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  // column numbers across the top
  getColumnLabels(numColumns).forEach((col, cIdx) => {
    const x = (cIdx + 1.5) * cellW;
    const y = cellH / 2;
    ctx.fillText(String(col), x, y);
  });

  // row letters down the left
  getRowLabels(numRows).forEach((rowL, rIdx) => {
    const x = cellW / 2;
    const y = (rIdx + 1.5) * cellH;
    ctx.fillText(rowL, x, y);
  });
  ctx.restore();
};
